module.exports = __webpack_public_path__ + "img/whatsapp-icon.cba18340.svg";